import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/logo-new.svg'
import _imports_1 from '@/assets/images/logo-mob.svg'


const _hoisted_1 = { class: "header-live" }
const _hoisted_2 = { class: "header-wrapper-shadow" }
const _hoisted_3 = { class: "header-container container" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "auction-live-info" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "live-progress" }
const _hoisted_8 = { class: "progress" }
const _hoisted_9 = { class: "progress-label" }
const _hoisted_10 = { class: "header__right" }
const _hoisted_11 = {
  key: 0,
  class: "count-bidders"
}
const _hoisted_12 = { class: "header__menu__language-switcher" }
const _hoisted_13 = { class: "language-switcher__text" }
const _hoisted_14 = { class: "languages-list" }
const _hoisted_15 = ["href", "onClick"]
const _hoisted_16 = {
  key: 1,
  class: "header__menu__login profile-name"
}
const _hoisted_17 = { class: "profile-name__text" }
const _hoisted_18 = { class: "user-name" }
const _hoisted_19 = { class: "profile-menu" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "profile-item" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "profile-item" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "profile-item" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "profile-item" }
const _hoisted_28 = { class: "profile-item-logout" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "subheader-mobile" }
const _hoisted_31 = { class: "container" }
const _hoisted_32 = { class: "subheader-mobile__wrapper" }
const _hoisted_33 = { class: "lot-number" }
const _hoisted_34 = { class: "auction-title" }

import { useAuctionStore } from "@/stores/AuctionStore";
  import { Menu as VMenu } from "floating-vue";
  import { trans } from "@/utils/trans";
  import { computed, watch } from "vue";
  import apiClient from "@/services/api";
  import { BaseIcon, WatchIcon } from "@/components/icons";
  import { LotStatuses } from "@/enum";
  import MobileMenuToggle from "@/components/menu-blocks/MobileMenuToggle.vue";
  import MobileMenu from "@/components/menu-blocks/MobileMenu.vue";
  import { ILanguage } from "@/models";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomHeader',
  setup(__props) {

  const auctionStore = useAuctionStore();

  const routes = computed(() => auctionStore.routes);
  const auction = computed(() => auctionStore.auction);
  const lots = computed(() => auctionStore.lots);
  const passedLots = computed(() =>
    lots.value.filter((item) => item.status === LotStatuses.LIVE || item.status === LotStatuses.ENDED)
  );

  const activeLot = computed(() => (auctionStore.activeLot?.id ? auctionStore.activeLot : auctionStore.fakeActiveLot));
  const auctionProgress = computed(() => parseInt(String((passedLots.value.length / lots.value.length) * 100)) || 0);
  const loginHref = computed(() => routes.value['login'] + '?redirect=' + location.href);

  const logout = () => {
    apiClient.post(routes.value["logout"]).then(() => {
      window.location.reload();
    });
  };

  const languages = computed(() => {
    return auctionStore.languageSettings.languages || [];
  });

  const switchLanguage = (language: ILanguage) => {
    apiClient.put(language.url).then((response) => {
      auctionStore.$patch((storeState) => {
        storeState.translations = response.data;
        storeState.languageSettings.language = language.abbr;
        storeState.languageSettings.htmlDirection = language.htmlDirection;
      });
    });
  };

  watch(
    () => auctionStore.languageSettings.language,
    (nv) => {
      const abbrArray = auctionStore.languageSettings?.languages.map((item) => item.abbr);
      const abbrs = abbrArray.join("|");
      let regexp = new RegExp(`^\\/(${abbrs})\\/`, "i");

      let matches = window.location.pathname.match(regexp);
      const abbrInPath = matches && matches?.length ? matches[1] : null;

      if (!nv) {
        if (abbrInPath && abbrArray?.includes(abbrInPath)) {
          let lang = auctionStore.languageSettings?.languages?.find((item) => item.abbr === abbrInPath);
          if (lang) {
            switchLanguage(lang);
          }
        }

        return;
      } else if (abbrInPath && nv == abbrInPath) {
        return;
      }

      const lang = auctionStore.languageSettings?.languages?.find((item) => item.abbr === nv);
      if (lang) {
        document.documentElement.setAttribute("lang", lang.abbr);
        document.documentElement.setAttribute("dir", lang.htmlDirection);

        let newPath = window.location.pathname;

        if (window.location.pathname.match(regexp)) {
          newPath = newPath.replace(regexp, `/${lang.abbr}/`);
        } else {
          newPath = `/${lang.abbr}${newPath}`;
        }
        newPath = newPath.replace(/^\/en\//, "/");

        window.history.replaceState("", "", newPath);
      }
    },
    { immediate: true }
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            href: routes.value['site.page_home.index'],
            class: "header__logo"
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              class: "header__logo__pc img",
              alt: "logo",
              width: "160",
              height: "58"
            }, null, -1),
            _createElementVNode("img", {
              src: _imports_1,
              class: "header__logo__mob img",
              alt: "logo",
              width: "43",
              height: "58"
            }, null, -1)
          ]), 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              href: routes.value['site.auction.show'],
              class: "auction-title"
            }, _toDisplayString(auction.value.title || ""), 9, _hoisted_6),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", {
                  class: "progress-line",
                  style: _normalizeStyle({ width: `${auctionProgress.value}%` })
                }, null, 4)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_unref(auctionStore).user?.is_admin)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(passedLots.value.length) + " / " + _toDisplayString(lots.value.length) + " [" + _toDisplayString(auctionProgress.value) + "%] ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(auctionProgress.value) + "%", 1)
                    ], 64))
              ])
            ], 512), [
              [_vShow, auction.value?.id]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (!_unref(auctionStore).user?.is_admin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(BaseIcon), {
                    "icon-name": "watch",
                    width: "26",
                    height: "16",
                    "view-box": "18.756 16.382 26.244 16.235"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(WatchIcon))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(trans)("header.live_bidders_count", { count: _unref(auctionStore)?.userOnLiveAnonymous || 0 })), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(VMenu), {
                placement: "bottom",
                theme: "info-tooltip",
                distance: 30
              }, {
                popper: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "languages-list__inner-wrapper",
                        key: language.id
                      }, [
                        _createElementVNode("a", {
                          class: "languages-list__item",
                          href: language.url,
                          onClick: _withModifiers(($event: any) => (switchLanguage(language)), ["prevent","stop"])
                        }, _toDisplayString(language.abbr), 9, _hoisted_15)
                      ]))
                    }), 128))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(auctionStore).languageSettings.language), 1)
                ]),
                _: 1
              })
            ]),
            (_unref(auctionStore).user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(VMenu), {
                      placement: "bottom",
                      theme: "info-tooltip",
                      distance: 30
                    }, {
                      popper: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("a", {
                            href: routes.value['profile.bids.active'],
                            class: "profile-item__inner-wrapper"
                          }, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(trans)("header.user_menu.bids")), 1)
                          ], 8, _hoisted_20),
                          _createElementVNode("a", {
                            href: routes.value['profile.invoices.index'],
                            class: "profile-item__inner-wrapper"
                          }, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(trans)("header.user_menu.purchases")), 1)
                          ], 8, _hoisted_22),
                          _createElementVNode("a", {
                            href: routes.value['profile.info.edit'],
                            class: "profile-item__inner-wrapper"
                          }, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(trans)("header.user_menu.profile")), 1)
                          ], 8, _hoisted_24),
                          _createElementVNode("a", {
                            href: routes.value['profile.notifications.edit'],
                            class: "profile-item__inner-wrapper"
                          }, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(trans)("header.user_menu.notifications")), 1)
                          ], 8, _hoisted_26),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(logout, ["prevent"]),
                            class: "profile-item__inner-wrapper-logout"
                          }, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(trans)("header.user_menu.logout")), 1)
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(auctionStore).user?.first_name || ""), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: loginHref.value,
                  class: "header__menu__login btn btn-dark-blue"
                }, _toDisplayString(_unref(trans)("header.login")), 9, _hoisted_29))
          ]),
          _createVNode(MobileMenuToggle, { class: "header-menu-open" })
        ])
      ]),
      _createVNode(MobileMenu)
    ]),
    _createElementVNode("header", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(trans)("live.common.main_info.lot_number", { number: activeLot.value?.lot_number })) + "  ", 1),
          _createElementVNode("span", _hoisted_34, _toDisplayString(activeLot.value?.title || ""), 1)
        ])
      ])
    ])
  ], 64))
}
}

})